import { fetch_wrapper } from './core'

/**
 * Simple API request
 * @param {string} path
 * @param {Object} [data] Will be JSON.stringify
 * @param {string} [method] POST by default
 * @param {string} [header_token] Bearer authorization header token
 * @param {string} [accept] Accept header, by default: `application/json`
 * @param {string} [contentType] Content-Type header, by default: `application/json`
 * @return {Promise<*>}
 */
export function simple_api_request ({
                                      path,
                                      data,
                                      method = 'POST',
                                      header_token,
                                      accept = 'application/json',
                                      contentType = 'application/json'
                                    }) {
  const headers = new Headers()
  headers.append('Accept', accept)
  headers.append('Content-Type', contentType)
  if (typeof header_token !== 'undefined') {
    headers.append('Authorization', 'Bearer ' + header_token)
  }
  let options = {
    method,
    headers
  }
  if (data) {
    options.body = JSON.stringify(data)
  }
  return fetch_wrapper(path, options)
}


// WEBPACK FOOTER //
// ./src/api/simple_api_request.js